document.addEventListener('DOMContentLoaded', function() {
  fetch('wcf3ab-qn.myshopify.com/api/2024-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '324fee3953eb6ca68131652d2c082d5b'
    },
    body: JSON.stringify({
      query: `query GetProductsByTag($collectionHandle: String!, $tagValue: String!, $first: Int = 20) {
        collection(handle: $collectionHandle) {
          products(first: $first, query: $tagValue) {
            edges {
              node {
                title
                handle
              }
            }
          }
        }
      }`,
      variables: {
        collectionHandle: "all",
        tagValue: "tag:'Microphone type___Built-in'",
        first: 20
      }
    })
  })
  .then(res => res.json())
  .then(data => {
    console.log("Filtered Products:", data);
    // Now, use data to render product list dynamically
  })
  .catch(err => console.error(err));
});
